import { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { newWorker } from 'shared/services/Worker';
import {
  UPLOAD_URL,
  MOMENT_URL,
  MOMENT_UPLOAD_URL
} from 'app/utils/Constants';

const UploadWorker = createContext(null);

export const UploadWorkerProvider = props => {
  const {
    children
  } = props;

  const [worker, setWorker] = useState(null);
  const user = useSelector(state => state.userReducer.user);

  useEffect(() => {
    let w = newWorker('/workers/portal/upload_worker.js?' + Date.now());
    setWorker(w);

    // terminate worker when provider unmounts
    return () => {
      w.terminate();
    }
  }, []);

  const createObjectURL = (file, callback) => {
    let fn = 'createObjectURL';
    let args = [file];

    worker.callFunction(fn, args, callback);
  }

  const loadPreview = (fileId, callback) => {
    let fn = 'loadPreview';
    let args = [fileId];

    worker.callFunction(fn, args, callback);
  }

  const loadGroupPreview = (groupId, callback) => {
    let fn = 'loadGroupPreview';
    let args = [groupId];

    worker.callFunction(fn, args, callback);
  }

  const startUpload = (files, fileContexts, hooks, callback) => {
    let fn = 'startUpload';
    let args = [user.token, files, fileContexts];
    let opts = {
      hooks
    }

    worker.callFunction(fn, args, callback, opts);
  }

  const getStatus = (matchFileContext, callback) => {
    let fn = 'getStatus';
    let args = [matchFileContext];

    worker.callFunction(fn, args, callback);
  }

  const abortFileUpload = fileId => {
    let fn = 'abortFileUpload';
    let args = [fileId];

    worker.callFunction(fn, args);
  }

  const abortGroupUpload = matchFileContext => {
    let fn = 'abortGroupUpload';
    let args = [matchFileContext];

    worker.callFunction(fn, args);
  }

  const onMessage = callback => {
    worker.addEventListener('message', callback);

    // return a function to clean up on unmount
    return () => {
      worker.removeEventListener('message', callback);
    }
  }

  // setup handle for child components
  const uploadWorker = {
    createObjectURL,
    loadPreview,
    loadGroupPreview,
    startUpload,
    getStatus,
    abortFileUpload,
    abortGroupUpload,
    onMessage
  }

  window.uploadWorker = uploadWorker;

  return (
    <UploadWorker.Provider value={uploadWorker}>
      {children}
    </UploadWorker.Provider>
  );
}

export default UploadWorker;
